/* eslint-disable vue/this-in-template */
<template>
  <section>
    <div
      v-if="newAwsAcctExistingClient.landing === true"
      class="agreement">
      <p>
        DXC’s AWS agreements require that all workloads be registered and approved for one of the discount tiers available.
        <br >Historically, we have applied whatever discount previous accounts have received for a given client to subsequent accounts.
        <br >However, we are able (and required) to register at the workload level…
        which means that a previous workload may have qualified for 1 discount and a subsequent workload could qualify for a better discount.
        <br >Detailed discount tier qualification and information is available in the Opportunity Registration guide. 
        In the Galaxy left column select "View and Download Guides" then select "Download OppReg guide".
      </p>

      <p>
        So – before we set up additional accounts, please answer the following questions.
        Based on your answers, we may require an AWS registration to be submitted and we will present questions accordingly.
      </p>
    </div>

    <div
      v-if="newAwsAcctExistingClient.landing === true"
      class="search">
      <v-container fluid>
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md6
            xl6>

            <v-autocomplete
              v-model="newAwsAcctExistingClient.selectedCustomer"
              :items="newAwsAcctExistingClient.customers"
              :search-input.sync="search"
              :disabled="newAwsAcctExistingClient.isCustomerFound"
              :item-text="(item) => `${item.Customer_Name} - ${item.Customer_Region}`"
              item-value="Customer_Id"
              label="Choose customer from this list of current DXC AWS customers"
              data-vv-validate-on="blur"
              cache-items
              flat
              hide-no-data
              hide-details
              attach
              light
              no-data-text="No results found"
            />
          </v-flex>
          <v-flex
            xs12
            sm12
            md3
            xl3>
            <v-checkbox
              v-model="newAwsAcctExistingClient.isCustomerFound"
              label="My customer not found"
              @change="isChecked()"
            />
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex
            xs12
            sm12
            md5
            xl5>
            <label>Is this an additional account to support a workload already in place?</label>
          </v-flex>
          <v-flex
            xs12
            sm12
            md3
            xl3>
            <v-btn-toggle
              v-model="newAwsAcctExistingClient.isAdditionalAcctSupport"
              @change="toggleAdditionalAcctSupport"
            >
              <v-btn
                value="Y"
                :disabled="newAwsAcctExistingClient.isCustomerFound || newAwsAcctExistingClient.selectedCustomer === null"
                class
                style="padding:15px 15px">Yes</v-btn>
              <v-btn
                value="N"
                :disabled="newAwsAcctExistingClient.isCustomerFound || newAwsAcctExistingClient.selectedCustomer === null"
                class
                style="padding:15px 15px">No</v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <formUserAwsCustomOnboardingList v-if="newAwsAcctExistingClient.registrationStep === 'listing' && newAwsAcctExistingClient.isAdditionalAcctSupport === 'Y'" />

    <formUserAwsAcctValidation
      v-if="newAwsAcctExistingClient.registrationStep === 'validation'"
      :type="'Existing'"
      @cancel="onAwsValidationCancel"
      @previous="goBackToListing"
      @save-for-later="onAwsValidationSaveForLater"
      @submit="onAwsValidationSubmit"/>

    <formReqAwsQuestionnaire
      v-if="newAwsAcctExistingClient.registrationStep === 'onboarding'"
      :type="'Existing'"
      @previous="goBackToValidation"
      @cancel="onQuestionnaireCancel"
      @continue="onOnboardingSubmit" />

    <formReqAwsContact
      v-if="newAwsAcctExistingClient.registrationStep === 'contact'"
      :type="'Existing'"
      @go-to-onboarding="goBackToQuestionnaire"
      @reset="onReset"
      @save="onContactsSave"/>

    <!-- ERROR MESSAGES -->
    <v-dialog
      v-model="newAwsAcctExistingClient.errorDialog1"
      persistent
      max-width="600px">
      <v-card>
        <v-card-text>This new workload must be registered to proceed. You should request <a
          href="#"
          @click="oppregLink">opportunity registration.</a></v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"/>
          <v-btn
            color="orange darken-1"
            text
            @click="newAwsAcctExistingClient.errorDialog1 = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      class="custom-dialog"
      v-model="newAwsAcctExistingClient.existingDialog1"
      persistent
      max-width="600px">
      <v-card>
        <v-card-text>This new workload must be registered to proceed. You should request <a
          href="#"
          @click="oppregLink">opportunity registration.</a></v-card-text>
          <v-container fluid>
              <v-layout row wrap style="margin:10px 0">
                <v-flex xs12 sm12 md10 xl10 >Do you have an Opportunity ID for this new account?</v-flex>
                  <v-flex xs12 sm12 md2 xl2 style="align:right">
                    <v-btn-toggle v-model="newAwsAcctExistingClient.q1 ">
                            <v-btn style="padding:10px 10px" value="Y">Yes</v-btn>
                            <v-btn style="padding:10px 10px" value="N">No</v-btn>
                    </v-btn-toggle>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md10 xl10 v-if="newAwsAcctExistingClient.q1==='Y'">Have you completed Opportunity Registration?</v-flex>
                <v-flex xs12 sm12 md2 xl2 v-if="newAwsAcctExistingClient.q1==='Y'" style="align:right">
                    <v-btn-toggle v-model="newAwsAcctExistingClient.q2">
                            <v-btn style="padding:10px 10px" value="Y">Yes</v-btn>
                            <v-btn style="padding:10px 10px" value="N">No</v-btn>
                    </v-btn-toggle>
                </v-flex>
                <!-- IF YES -->
                <v-flex xs12 sm12 md12 xl12 v-if="newAwsAcctExistingClient.q2 ==='Y' && newAwsAcctExistingClient.q1 ==='Y'">
                 <v-text-field 
                      label="OppReg Id" 
                      v-model="newAwsAcctExistingClient.OppRegId"
                      :error = "newAwsAcctExistingClient.OppRegIdExistError"
                      :error-messages = "newAwsAcctExistingClient.OppRegIdExistErrorMessage"
                      :success = "newAwsAcctExistingClient.OppRegIdExistSuccess"
                      :success-messages = "newAwsAcctExistingClient.OppRegIdExistSuccessMessage">
                       <template v-slot:append>
                        <v-btn class="my-0" small 
                        :loading ="newAwsAcctExistingClient.OppRegIdExistLoading" 
                        @click="checkOppregId">
                         <span v-if="newAwsAcctExistingClient.OppregIdValidated === false && newAwsAcctExistingClient.OppRegIdExistSuccess === false">validate</span>
                        <v-icon
                          v-if="newAwsAcctExistingClient.OppregIdValidated === true && newAwsAcctExistingClient.OppRegIdExistSuccess === true"
                          small>check</v-icon>
                        </v-btn>
                       </template> 
                   </v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 xl12 v-if="newAwsAcctExistingClient.q2 === 'Y' && newAwsAcctExistingClient.OppRegIdExistSuccess === true">
                   <v-autocomplete
                      label="Choose a Workload"
                      v-model="newAwsAcctExistingClient.projectId"
                      :items="filterWorkloads"
                      item-text="Workload_Title"
                      item-value="Project_Id"
                    ></v-autocomplete>
                </v-flex>
              
              </v-layout>
              <v-layout row wrap style="margin:10px 0">
                  <!-- IF NO  -->
                <v-flex xs12 sm12 md12 xl12 v-if="newAwsAcctExistingClient.q1==='N' || newAwsAcctExistingClient.q2 ==='N'">
                  <span style="font-weight:500">Please complete  <a href="#" @click="oppregLink">Opportunity Registration</a> before you proceed.</span>
                </v-flex>
              </v-layout> 
            </v-container>
        <v-card-actions>
           <v-btn color="warning" @click="hideOppregDialog">Close</v-btn>
                  <v-btn 
                   v-if="newAwsAcctExistingClient.q2==='Y' && newAwsAcctExistingClient.OppRegIdExistSuccess === true"
                  :disabled="newAwsAcctExistingClient.OppRegId === '' || newAwsAcctExistingClient.projectId === ''"
                  class="opp-btn"
                  color="warning"
                  @click="setSelectedAccount">Next</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



  </section>
</template>

<script>
import { METHODS } from 'http'
import { Validator } from 'vee-validate'
import { mapMutations, mapState, mapActions } from 'vuex'

export default {

  data () {
    return {
      nq1: null,
      nq2: null,

      OppRegId:null,
    }
  },
  mounted () {
    let type = 'existing'
    this.$store.dispatch('user/requestAws/getCustomers', type)
    this.$store.dispatch('user/requestAws/getMPayers')
    this.$store.commit('user/requestAws/clearExistingAccount')
    this.$store.commit('user/requestAws/clearExistingAwsAcctValidation')
    this.$store.commit('user/requestAws/clearExistingAwsOnboarding')
    this.$store.commit('user/requestAws/clearExistingAwsOnboardingContacts')
  },
  computed: {
    ...mapState('user/requestAws', ['newAwsAcctExistingClient']),

    filterWorkloads () {
      let workloadStatus = [
        'Approved - Tier 1 23% - PPA',
        'Approved - Tier 1 23% - PPA SaaS',
        'Approved - Tier 3 12%',
        'Approved - Tier 2 - Custom EDP',
        'AWS Reg Accepted',
        'LEGACY - Approved - Tier 1 23% - PPA',
        'LEGACY - Approved - Tier 1 23% - PPA SaaS',
        'LEGACY - Approved - Tier 3 12%',
        'LEGACY - Approved - Tier 2 - Custom EDP'
      ]
      // return this.newAwsAcctExistingClient.workloads.filter(workload => workloadStatus.includes(workload.Workload_Status))
      return this.newAwsAcctExistingClient.workloads.filter(workload => workloadStatus.some(status => workload.Workload_Status.includes(status)))
    }

  },
  beforeDestroy () {
  },
  methods: {
    ...mapActions({
      getOnboardingByCustId: 'user/requestAws/getAwsOnboarding'
    }),
    isChecked () {
      if (this.newAwsAcctExistingClient.isCustomerFound) {
        this.newAwsAcctExistingClient.errorDialog1 = true
      }
    },
    toggleAdditionalAcctSupport () {
      console.log('Additional Account Support: ', this.newAwsAcctExistingClient.isAdditionalAcctSupport)
      console.log('Registration Step: ', this.newAwsAcctExistingClient.registrationStep)
      if (this.newAwsAcctExistingClient.isAdditionalAcctSupport === 'N') {
        this.getOnboardingByCustId({custId: this.newAwsAcctExistingClient.selectedCustomer,isAdditionalAcctSupport: 'N' })
        this.newAwsAcctExistingClient.existingDialog1 = true
      } else if (this.newAwsAcctExistingClient.isAdditionalAcctSupport === 'Y') {
        this.newAwsAcctExistingClient.registrationStep = 'listing'
        this.getOnboardingByCustId({custId: this.newAwsAcctExistingClient.selectedCustomer,isAdditionalAcctSupport: 'Y' })
      }
    },
    goBackToListing () {
      console.log('-- tesst go back to listing --')
      console.log('Dialog: '+ this.newAwsAcctExistingClient.dialog)
      if(this.newAwsAcctExistingClient.dialog !== '') {
        this.$store.commit('user/requestAws/setExistingLanding', {status: true, landing: true, dialog: this.newAwsAcctExistingClient.dialog})
      } else {
         this.$store.commit('user/requestAws/setExistingLanding', {status: true, landing: true})
      }
     
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'listing')
    },
    goBackToValidation () {
      console.log('-- tessst GO BACK to validation ----')
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'validation')
    },
    goBackToQuestionnaire () {
      console.log('-- Go Back to Questionnaire --')
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'onboarding')
    },
    // EVENTS FOR VALIDATION STEP
    onAwsValidationCancel () {
      // event for cancel aws validation button
      this.$store.commit('user/requestAws/clearValidation')
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'listing')
    },
    onAwsValidationSaveForLater (data) {
      // event for save for later aws validation button
      // this.$store.state['user/requestAws'].newAwsAccount.accountRecord.onboarding
      // here we dispatch the onboarding-header record creation
      this.$store.dispatch('user/requestAws/createOnboardingAccount',
        this.$store.state['user/requestAws'].newAwsAcctExistingClient.accountRecord.onboarding
      )
    },
    onAwsValidationSubmit (data) {
      // event for submit aws validation button
      // this.$store.dispatch('user/requestAws/insertWbsAndIwoExisting', data)
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'onboarding')
    },
    onOnboardingSubmit (onboarding) {
      console.log('----- onOnboardingSubmit -----')
      console.table(onboarding)
      // update onboarding state under Account Record
      this.$store.commit('user/requestAws/updateOnboardingExisting', onboarding)
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'contact')
    },
    onContactsSave (contacts) {
      this.$store.commit('user/requestAws/updateOnboardingContactsExisting', contacts)
    
      let selCustomer = this.newAwsAcctExistingClient.customers.filter(res => {return res.Customer_Id === this.newAwsAcctExistingClient.selectedCustomer})
      // here we dispatch the onboarding-header record creation
      this.$store.dispatch('user/requestAws/createOnboardingAccount',
       { 
         record: this.$store.state['user/requestAws'].newAwsAcctExistingClient.accountRecord.onboarding,
         oppregStatus: this.$store.state['user/requestAws'].newAwsAcctExistingClient.Workload_Status,
         mpid: selCustomer[0].Master_Id,
         type: 'existing'
       }
      )
    },
    onReset () {
      this.$store.commit('user/requestAws/clearExistingAccount')
      // clear AWSAccount validation State
      this.$store.commit('user/requestAws/clearExistingAwsAcctValidation')
      this.$store.commit('user/requestAws/clearExistingAwsOnboarding')
      this.$store.commit('user/requestAws/clearExistingAwsOnboardingContacts')
    },
    hideOppregDialog () {
      this.$store.commit('user/requestAws/clearExistingOppregIdModal')
    },
    checkOppregId() {
      if(this.newAwsAcctExistingClient.OppRegId !== ''){
        let obj = {
        awsType: 'external',
        oppId: this.newAwsAcctExistingClient.OppRegId
      }
      //  this.$store.dispatch('user/requestAws/onOppIdValidate', obj )

        if(this.newAwsAcctExistingClient.OppRegId.substring(0,6) !== 'DXCINT' && this.newAwsAcctExistingClient.OppRegId.substring(0,6) !== 'DXCSUB') {
          console.log('!!!!! validate !!!!!!')
          this.$store.dispatch('user/requestAws/onOppIdValidate', obj )
        } else {
          this.$store.commit('user/requestAws/setOppRegIdAvailabilityMessage', { awsType: 'external', type: 'error', message: 'You entered a DXC Internal Opportunity Id'})
        }

      } else {
        this.$store.commit('user/requestAws/setOppRegIdAvailabilityMessage', { awsType: 'external', type:'error',  message: 'Opportunity Registration ID is empty'})
      }
    },
    setSelectedAccount () {
      let customerAlias =  this.newAwsAcctExistingClient.customers.filter( cust => cust.Customer_Id === this.newAwsAcctExistingClient.selectedCustomer)
      let AdditionalAcct =  this.newAwsAcctExistingClient.isAdditionalAcctSupport
      let selWorkload =  this.newAwsAcctExistingClient.workloads.filter(workload =>   workload.Project_Id === this.newAwsAcctExistingClient.projectId  )
      console.log('*** selworkload ***')
      console.log(selWorkload)
      console.log('******************')

      console.log('selected customer: '+ this.newAwsAcctExistingClient.selectedCustomer)

      let selCustomer = this.newAwsAcctExistingClient.customers.filter(res => {return res.Customer_Id === this.newAwsAcctExistingClient.selectedCustomer})
      console.log('####### selCustomer #######')
      console.log(selCustomer)
      console.log(selCustomer[0].Master_Id)
      console.log('###########################')
      let selCustomerAgreement = this.newAwsAcctExistingClient.masterpayers.filter(res => {return res.MP_ID === selCustomer[0].Master_Id})
      

      console.log('Customer Alias: ', customerAlias[0].Customer_Alias)
      console.log('Additional Acct: ', AdditionalAcct)
      let agreement 
      if(selCustomerAgreement.length > 0) {
        console.log('selected Customer Agreement: '+ selCustomerAgreement[0].Agreement)
        agreement = selCustomerAgreement[0].Agreement
      }
      
      let account = {
        mirrorAcct: AdditionalAcct, 
        projectId: this.newAwsAcctExistingClient.projectId,
        Customer_Id: customerAlias[0].Customer_Id,
        Customer_Alias: customerAlias[0].Customer_Alias,
        workloadType: selWorkload[0].Workload_type,
        Workload_Status: selWorkload[0].Workload_Status,
        selCustAgreement:agreement
      }

      this.$store.commit('user/requestAws/setSelecteNoRegIdAcct', account)
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'validation')
      this.$store.commit('user/requestAws/setExistingLanding', {status: false, dialog:'dialog1', landing: false})
    },
    oppregLink () {
      vm.$router.push({ path: `/request-oppreg/external-oppreg` })
    }


  }
}
</script>

<style lang="scss" scoped>
section {
  padding: 15px 15px;
  height: 100%;
  background-color: #ffffff;
  .v-autocomplete__content.v-menu__content {
    left: 50% !important;
  }
  .agreement {
    background-color: #ff9900 !important;
    border-radius: 50px 20px;
    color: #000000;
    font-weight: 400;
    padding: 25px 30px;
  }

  .agreement > p {
    font-size: 18px !important;
    font-weight: 500;
  }
  .search {
    // background:#E3E3E4;
    background: rgb(246, 246, 246);
    background: linear-gradient(
      90deg,
      rgba(246, 246, 246, 1) 0%,
      rgba(228, 227, 227, 1) 41%,
      rgba(226, 229, 229, 1) 100%
    );
    margin: 15px 0;
    border-radius: 10px;
    padding: 15px 10px;
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: 400;
    font-size: 14px;
  }
  .v-btn-toggle .v-btn.v-btn--active{
    background-color: #ff9900 !important;
  }
}
 .v-dialog{
      .v-btn-toggle .v-btn.v-btn--active{
     background-color:#ff9900 !important;
   }
  }

</style>
